/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offline_Sync_Caption_File_TimecodesInputs */

const en_offline_sync_caption_file_timecodes = /** @type {(inputs: Offline_Sync_Caption_File_TimecodesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Event Group Timecodes are based on caption file`)
};

const fr_offline_sync_caption_file_timecodes = /** @type {(inputs: Offline_Sync_Caption_File_TimecodesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les timecodes du groupe d'événements sont basés sur un fichier de sous-titres`)
};

const de_offline_sync_caption_file_timecodes = /** @type {(inputs: Offline_Sync_Caption_File_TimecodesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zeitcodes der Ereignisgruppe basieren auf einer Untertiteldatei`)
};

const it_offline_sync_caption_file_timecodes = /** @type {(inputs: Offline_Sync_Caption_File_TimecodesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I timecode del gruppo eventi sono basati su un file sottotitoli`)
};

const ru_offline_sync_caption_file_timecodes = /** @type {(inputs: Offline_Sync_Caption_File_TimecodesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Таймкоды группы событий основаны на файле субтитров`)
};

const es_offline_sync_caption_file_timecodes = /** @type {(inputs: Offline_Sync_Caption_File_TimecodesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Los códigos de tiempo del grupo de eventos están basados en un archivo de subtítulos`)
};

const zh_cn2_offline_sync_caption_file_timecodes = /** @type {(inputs: Offline_Sync_Caption_File_TimecodesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`事件组时间码基于字幕文件`)
};

const ja_offline_sync_caption_file_timecodes = /** @type {(inputs: Offline_Sync_Caption_File_TimecodesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イベントグループのタイムコードは字幕ファイルに基づいている`)
};

const hi_offline_sync_caption_file_timecodes = /** @type {(inputs: Offline_Sync_Caption_File_TimecodesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इवेंट समूह के टाइमकोड कैप्शन फ़ाइल पर आधारित हैं`)
};

const pt_pt2_offline_sync_caption_file_timecodes = /** @type {(inputs: Offline_Sync_Caption_File_TimecodesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Os códigos de tempo do grupo de eventos baseiam-se num ficheiro de legendas`)
};

/**
* | output |
* | --- |
* | "Event Group Timecodes are based on caption file" |
*
* @param {Offline_Sync_Caption_File_TimecodesInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const offline_sync_caption_file_timecodes = /** @type {((inputs?: Offline_Sync_Caption_File_TimecodesInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offline_Sync_Caption_File_TimecodesInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_offline_sync_caption_file_timecodes(inputs)
	if (locale === "de") return de_offline_sync_caption_file_timecodes(inputs)
	if (locale === "it") return it_offline_sync_caption_file_timecodes(inputs)
	if (locale === "ru") return ru_offline_sync_caption_file_timecodes(inputs)
	if (locale === "es") return es_offline_sync_caption_file_timecodes(inputs)
	if (locale === "zh-CN") return zh_cn2_offline_sync_caption_file_timecodes(inputs)
	if (locale === "ja") return ja_offline_sync_caption_file_timecodes(inputs)
	if (locale === "hi") return hi_offline_sync_caption_file_timecodes(inputs)
	if (locale === "pt-PT") return pt_pt2_offline_sync_caption_file_timecodes(inputs)
	return en_offline_sync_caption_file_timecodes(inputs)
});